import { render, staticRenderFns } from "./WeekPeriodRuleSetting.vue?vue&type=template&id=be60963e"
import script from "./WeekPeriodRuleSetting.vue?vue&type=script&lang=js"
export * from "./WeekPeriodRuleSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports